import { Datagrid, NumberField, SimpleList, TextField, DateField, ReferenceField } from 'react-admin';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme } from '@mui/material';
import { UploadButton } from '@components/UploadButton';
import env from '@src/environment';

export const TargetList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    return (
        <InfiniteList>
            {isSmall ? (
                <SimpleList
                    primaryText={record => (
                        <ReferenceField source="storeId" reference="store">
                            <TextField source="name" />
                        </ReferenceField>
                    )}
                    /*secondaryText={record => record.credit_balance}*/
                    tertiaryText={record => (
                        <NumberField
                            source="target"
                            locales={env.localFormat}
                            textAlign="right"
                        />
                    )}
                />
            ) : (
                <Datagrid>
                    <ReferenceField source="storeId" reference="store">
                        <TextField source="name" />
                    </ReferenceField>
                    <NumberField
                        source="target"
                        locales={env.localFormat}
                        textAlign="right"
                    />
                    <DateField source="effDateFrom" />
                    <DateField source="effDateTo" />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
